import { memo } from "react";
import {
  Box,
  Button,
  Checkbox,
  HStack,
  Icon,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FiShield } from "react-icons/fi";
import { InvestmentAgreementProps } from "./types";

export const InvestmentAgreement = memo(({
  agreed,
  agreementOpen,
  borderColor,
  cardBg,
  subtitleColor,
  textColor,
  setAgreed,
  setAgreementOpen,
}: InvestmentAgreementProps) => (
  <>
    <Box
      bg={cardBg}
      borderRadius="2xl"
      border="1px solid"
      borderColor={borderColor}
      p={5}
    >
      <Checkbox
        isChecked={agreed}
        onChange={(e) => setAgreed(e.target.checked)}
        colorScheme="brand"
        alignItems="flex-start"
      >
        <Text fontSize="sm" color={textColor} mt={0.5}>
          قوانین را مطالعه کرده و قبول دارم —{" "}
          <Link
            color="brand.500"
            fontWeight="semibold"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setAgreementOpen(true);
            }}
            cursor="pointer"
            textDecoration="underline"
          >
            مشاهده قوانین
          </Link>
        </Text>
      </Checkbox>
    </Box>

    <Modal
      isOpen={agreementOpen}
      onClose={() => setAgreementOpen(false)}
      isCentered
      scrollBehavior="inside"
      size="md"
    >
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent borderRadius="2xl" mx={4} pt="40px">
        <ModalHeader
          fontSize="md"
          borderBottom="1px solid"
          borderColor={borderColor}
        >
          <HStack spacing={2}>
            <Icon
              verticalAlign="middle"
              as={FiShield as any}
              color="brand.500"
              boxSize={4}
            />
            <Text>قوانین و مقررات خرید آسان</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody py={5} fontSize="sm" color={subtitleColor} lineHeight="tall">
          <VStack spacing={3} align="stretch">
            <Text>
              ۱. سرمایه‌گذاری در صندوق می‌تواند با ریسک کاهش ارزش دارایی همراه
              باشد.
            </Text>
            <Text>
              ۲. اطلاعات این صفحه صرفاً جهت اطلاع‌رسانی بوده و توصیه
              سرمایه‌گذاری نیست.
            </Text>
            <Text>
              ۳. کارمزد صدور و ابطال طبق قوانین سازمان بورس محاسبه می‌شود.
            </Text>
            <Text>۴. زمان تسویه ابطال ممکن است تا ۷ روز کاری طول بکشد.</Text>
            <Text>
              ۵. NAV اعلامی مبنای صدور و ابطال است و ممکن است با NAV روز تفاوت
              داشته باشد.
            </Text>
            <Text>
              ۶. درخواست صدور پس از واریز مبلغ در اولین روز کاری پردازش می‌شود.
            </Text>
            <Text>
              ۷. با ثبت درخواست، تمام قوانین و مقررات فوق را پذیرفته‌اید.
            </Text>
          </VStack>
          <Button
            colorScheme="brand"
            w="100%"
            mt={6}
            mb={2}
            borderRadius="xl"
            onClick={() => {
              setAgreed(true);
              setAgreementOpen(false);
            }}
          >
            قبول دارم
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  </>
));

InvestmentAgreement.displayName = "InvestmentAgreement";
